const Appetizers = [
  {
    Category: "Appetizers",
    Name: "Chicken Wings (8)",
    Price: 7.75,
  },
  {
    Category: "Appetizers",
    Name: "Steamed Pork Dumplings (10)",
    Price: 8.75,
  },
  {
    Category: "Appetizers",
    Name: "Deep Fried Pork Dumplings (10)",
    Price: 7.25,
  },
  {
    Category: "Appetizers",
    Name: "Pan Fried Pork Dumplings (10)",
    Price: 7.25,
  },
  {
    Category: "Appetizers",
    Name: "Spring Rolls (2)",
    Price: 2.75,
  },
  {
    Category: "Appetizers",
    Name: "Chicken Egg Roll",
    Price: 1.5,
  },
  {
    Category: "Appetizers",
    Name: "Krab Rangoons (10)",
    Price: 6.55,
  },
  {
    Category: "Appetizers",
    Name: "Edamame Soy Beans",
    Price: 4.25,
  },
  {
    Category: "Appetizers",
    Name: "Seaweed Salad",
    Price: 4.25,
  },
  {
    Category: "Appetizers",
    Name: "Grilled Shrimps on a Stick (6)",
    Price: 6.25,
  },
  {
    Category: "Appetizers",
    Name: "Beef Sticks",
    Price: 6.25,
  },
  {
    Category: "Appetizers",
    Name: "Chicken Sticks",
    Price: 6.25,
  },
  {
    Category: "Appetizers",
    Name: "Chinese Doughnuts",
    Price: 4.25,
  },
];

export const Drinks = [
  {
    Category: "Drinks",
    Name: "Coke (2 Liters)",
    Price: 3.25,
  },
  {
    Category: "Drinks",
    Name: "Diet Coke (2 Liters)",
    Price: 3.25,
  },
  {
    Category: "Drinks",
    Name: "Sprite (2 Liters)",
    Price: 3.25,
  },
  {
    Category: "Drinks",
    Name: "Mountain Dew (2 Liters)",
    Price: 3.25,
  },
  {
    Category: "Drinks",
    Name: "Coke (Can)",
    Price: 1,
  },
  {
    Category: "Drinks",
    Name: "Diet Coke (Can)",
    Price: 1,
  },
  {
    Category: "Drinks",
    Name: "Sprite (Can)",
    Price: 1,
  },
  {
    Category: "Drinks",
    Name: "Mountain Dew (Can)",
    Price: 1,
  },
  {
    Category: "Drinks",
    Name: "Bottled Water",
    Price: 1,
  },
];

const FriedRice = [
  {
    Category: "Fried Rice",
    Name: "Vegetable Fried Rice",
    SmallPrice: 5.5,
    LargePrice: 7.5,
  },
  {
    Category: "Fried Rice",
    Name: "Chicken Fried Rice",
    SmallPrice: 6.5,
    LargePrice: 8.95,
  },
  {
    Category: "Fried Rice",
    Name: "Pork Fried Rice",
    SmallPrice: 6.5,
    LargePrice: 8.95,
  },
  {
    Category: "Fried Rice",
    Name: "Beef Fried Rice",
    SmallPrice: 6.5,
    LargePrice: 8.95,
  },
  {
    Category: "Fried Rice",
    Name: "Shrimp Fried Rice",
    SmallPrice: 6.5,
    LargePrice: 8.95,
  },
  {
    Category: "Fried Rice",
    Name: "House Fried Rice",
    SmallPrice: 6.95,
    LargePrice: 9.5,
    ItemDescription: "(Beef, Chicken, and Shrimp)",
  },
];

const LoMein = [
  {
    Category: "Lo Mein",
    Name: "Plain Lo Mein",
    SmallPrice: 5.5,
    LargePrice: 7.95,
    CategoryDesc: "(Soft Noodles)",
  },
  {
    Category: "Lo Mein",
    Name: "Vegetable Lo Mein",
    SmallPrice: 5.75,
    LargePrice: 8.25,
  },
  {
    Category: "Lo Mein",
    Name: "Chicken Lo Mein",
    SmallPrice: 6.5,
    LargePrice: 9.25,
  },
  {
    Category: "Lo Mein",
    Name: "Pork Lo Mein",
    SmallPrice: 6.5,
    LargePrice: 9.25,
  },
  {
    Category: "Lo Mein",
    Name: "Shrimp Lo Mein",
    SmallPrice: 6.5,
    LargePrice: 9.25,
  },
  {
    Category: "Lo Mein",
    Name: "Beef Lo Mein",
    SmallPrice: 6.5,
    LargePrice: 9.25,
  },
  {
    Category: "Lo Mein",
    Name: "House Special Lo Mein",
    SmallPrice: 6.95,
    LargePrice: 9.95,
    ItemDescription: "(With Beef, Chicken, and Shrimp)",
  },
  {
    Category: "Lo Mein",
    Name: "House Special Rice Noodle",
    LargePrice: 9.95,
    ItemDescription: "(With Beef, Chicken, and Shrimp)",
  },
];

const Soup = [
  {
    Category: "Soup",
    Name: "Miso Soup",
    SmallPrice: 2.95,
    LargePrice: 4.95,
  },
  {
    Category: "Soup",
    Name: "Chicken Wonton Soup",
    SmallPrice: 2.95,
    LargePrice: 4.95,
  },
  {
    Category: "Soup",
    Name: "Egg Drop Soup",
    SmallPrice: 2.95,
    LargePrice: 4.95,
  },
  {
    Category: "Soup",
    Name: "Hot Sour Soup",
    SmallPrice: 2.95,
    LargePrice: 4.95,
    isSpicy: true,
  },
  {
    Category: "Soup",
    Name: "Vegetable Tofu Soup",
    Price: 5.25,
  },
];

const Vegetables = [
  {
    Category: "Vegetables",
    Name: "Mixed Veggies",
    SmallPrice: 5.95,
    LargePrice: 8.95,
    CategoryDesc: "(With White Rice)",
  },
  {
    Category: "Vegetables",
    Name: "Broccoli with Garlic Sauce",
    SmallPrice: 5.95,
    LargePrice: 8.95,
    isSpicy: true,
  },
  {
    Category: "Vegetables",
    Name: "Home Style Tofu",
    Price: 9.5,
  },
];

const DietFood = [
  {
    Category: "Diet Food",
    Name: "Steamed Mixed Veggies",
    Price: 8.95,
    CategoryDesc: "(With White Rice)",
  },
  {
    Category: "Diet Food",
    Name: "Steamed Tofu with Mixed Veggies",
    Price: 9.5,
  },
  {
    Category: "Diet Food",
    Name: "Steamed Chicken with Mixed Veggies",
    Price: 11.75,
  },
  {
    Category: "Diet Food",
    Name: "Steamed Shrimp with Mixed Veggies",
    Price: 11.75,
  },
  {
    Category: "Diet Food",
    Name: "Steamed Chicken with Broccoli",
    Price: 11.75,
  },
  {
    Category: "Diet Food",
    Name: "Steamed Shrimp with Broccoli",
    Price: 11.75,
  },
];

const Chicken = [
  {
    Category: "Chicken",
    Name: "Sweet and Sour Chicken",
    SmallPrice: 6.55,
    LargePrice: 10.75,
  },
  {
    Category: "Chicken",
    Name: "Chicken with Broccoli",
    SmallPrice: 7.25,
    LargePrice: 11.75,
  },
  {
    Category: "Chicken",
    Name: "Bourbon Chicken",
    SmallPrice: 7.25,
    LargePrice: 11.75,
  },
  {
    Category: "Chicken",
    Name: "Chicken with Mixed Veggies",
    SmallPrice: 7.25,
    LargePrice: 11.75,
  },
  {
    Category: "Chicken",
    Name: "Chicken with Garlic Sauce",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Chicken",
    Name: "Szechuan Chicken",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Chicken",
    Name: "Hunan Chicken",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Chicken",
    Name: "Sesame Chicken",
    SmallPrice: 7.25,
    LargePrice: 11.75,
  },
  {
    Category: "Chicken",
    Name: "Orange Chicken",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Chicken",
    Name: "General Tso's Chicken",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Chicken",
    Name: "White Meat Bourbon Chicken",
    SmallPrice: 7.25,
    LargePrice: 11.75,
  },
  {
    Category: "Chicken",
    Name: "Kung Pao Chicken",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Chicken",
    Name: "Chicken with Cashew",
    SmallPrice: 7.25,
    LargePrice: 11.75,
  },
  {
    Category: "Chicken",
    Name: "Chicken with Curry Sauce",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Chicken",
    Name: "Moo Goo Gai Pan",
    SmallPrice: 7.25,
    LargePrice: 11.75,
  },
];

const Beef = [
  {
    Category: "Beef",
    Name: "Beef with Broccoli",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    CategoryDesc: "(With White Rice)",
  },
  {
    Category: "Beef",
    Name: "Szechuan Beef",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Beef",
    Name: "Hunan Beef",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Beef",
    Name: "Beef with Mixed Veggies",
    SmallPrice: 7.25,
    LargePrice: 11.75,
  },
  {
    Category: "Beef",
    Name: "Beef with Garlic Sauce",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Beef",
    Name: "Mongolian Beef",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Beef",
    Name: "Kung Pao Beef",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Beef",
    Name: "Beef with Cashew",
    SmallPrice: 7.25,
    LargePrice: 11.75,
  },
  {
    Category: "Beef",
    Name: "Beef with Curry Sauce",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
];

const Seafood = [
  {
    Category: "Seafood",
    Name: "Shrimp with Broccoli",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    CategoryDesc: "(With White Rice)",
  },
  {
    Category: "Seafood",
    Name: "Shrimp with Lobster Sauce",
    SmallPrice: 7.25,
    LargePrice: 11.75,
  },
  {
    Category: "Seafood",
    Name: "Shrimp with Mixed Veggies",
    SmallPrice: 7.25,
    LargePrice: 11.75,
  },
  {
    Category: "Seafood",
    Name: "Shrimp with Garlic Sauce",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Seafood",
    Name: "Szechuan Shrimp",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Seafood",
    Name: "Hunan Shrimp",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Seafood",
    Name: "Kung Pao Shrimp",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
  {
    Category: "Seafood",
    Name: "Shrimp with Cashew",
    SmallPrice: 7.25,
    LargePrice: 11.75,
  },
  {
    Category: "Seafood",
    Name: "Shrimp with Curry Sauce",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    isSpicy: true,
  },
];

const Teriyaki = [
  {
    Category: "Teriyaki",
    Name: "Teriyaki Chicken",
    SmallPrice: 7.25,
    LargePrice: 11.75,
    CategoryDesc: "(With White Rice)",
  },
  {
    Category: "Teriyaki",
    Name: "Teriyaki Beef",
    SmallPrice: 7.25,
    LargePrice: 11.75,
  },
  {
    Category: "Teriyaki",
    Name: "Teriyaki Shrimp",
    SmallPrice: 7.25,
    LargePrice: 11.75,
  },
  {
    Category: "Teriyaki",
    Name: "Teriyaki Chicken Breast",
    SmallPrice: 7.15,
    LargePrice: 11.75,
  },
  {
    Category: "Teriyaki",
    Name: "Teriyaki Chicken and Shrimp",
    SmallPrice: 7.75,
    LargePrice: 11.95,
  },
  {
    Category: "Teriyaki",
    Name: "Teriyaki Chicken and Beef",
    SmallPrice: 7.75,
    LargePrice: 11.95,
  },
  {
    Category: "Teriyaki",
    Name: "Teriyaki Beef and Shrimp",
    SmallPrice: 7.75,
    LargePrice: 11.95,
  },
];

const ChowMein = [
  {
    Category: "Chow Mein",
    Name: "Vegetable Chow Mein",
    SmallPrice: 5.95,
    LargePrice: 8.95,
    CategoryDesc: "(With Crispy Noodles and White Rice)",
  },
  {
    Category: "Chow Mein",
    Name: "Chicken Chow Mein",
    SmallPrice: 6.75,
    LargePrice: 10.75,
  },
  {
    Category: "Chow Mein",
    Name: "Pork Chow Mein",
    SmallPrice: 6.75,
    LargePrice: 10.75,
  },
  {
    Category: "Chow Mein",
    Name: "Beef Chow Mein",
    SmallPrice: 6.75,
    LargePrice: 10.75,
  },
  {
    Category: "Chow Mein",
    Name: "Shrimp Chow Mein",
    SmallPrice: 6.75,
    LargePrice: 10.75,
  },
  {
    Category: "Chow Mein",
    Name: "House Special Chow Mein",
    SmallPrice: 6.75,
    LargePrice: 10.75,
    ItemDescription: "(With Pork, Chicken, and Shrimp)",
  },
];

export const ChopSuey = [
  {
    Category: "Chop Suey",
    Name: "Vegetable Chop Suey",
    SmallPrice: 6.75,
    LargePrice: 10.75,
    CategoryDesc: "(With Crispy Noodles and White Rice)",
  },
  {
    Category: "Chop Suey",
    Name: "Chicken Chop Suey",
    SmallPrice: 6.75,
    LargePrice: 10.75,
  },
  {
    Category: "Chop Suey",
    Name: "Pork Chop Suey",
    SmallPrice: 6.75,
    LargePrice: 10.75,
  },
  {
    Category: "Chop Suey",
    Name: "Beef Chop Suey",
    SmallPrice: 6.75,
    LargePrice: 10.75,
  },
  {
    Category: "Chop Suey",
    Name: "Shrimp Chop Suey",
    SmallPrice: 6.75,
    LargePrice: 10.75,
  },
];

const ChefsSpecialties = [
  {
    Category: "Chef's Specialties",
    Name: "General Tso's Chicken Breast",
    Price: 12.5,
    isSpicy: true,
    ItemDescription:
      "(Crispy chicken breast tossed in a Sweet and Spicy sauce)",
    CategoryDesc: "(With White Rice, Add $0.50 for Brown Rice)",
  },
  {
    Category: "Chef's Specialties",
    Name: "Sesame Chicken Breast",
    Price: 12.5,
    ItemDescription: "(Crispy chicken breast tossed in a Sweet Sauce)",
  },
  {
    Category: "Chef's Specialties",
    Name: "Teriyaki Combo",
    Price: 13.5,
    ItemDescription:
      "(Grilled Chicken, Beef, and Jumbo Shrimp with Teriyaki Sauce)",
  },
  {
    Category: "Chef's Specialties",
    Name: "General Tso's Shrimp",
    Price: 13.5,
    ItemDescription: "(Crispy Shrimp cooked in General Tso's Sauce)",
    isSpicy: true,
  },
  {
    Category: "Chef's Specialties",
    Name: "Sesame Shrimp",
    Price: 13.5,
    ItemDescription: "(Crispy Shrimp cooked in Sesame Sauce)",
  },
  {
    Category: "Chef's Specialties",
    Name: "Happy Family",
    Price: 13.5,
    ItemDescription:
      "(Shrimp, Chicken, Beef, Scallops, and Pork, mixed w/ special sauce)",
  },
  {
    Category: "Chef's Specialties",
    Name: "Double Delight",
    Price: 12.5,
    ItemDescription: "(Chicken and Beef mixed in Brown Sauce)",
  },
  {
    Category: "Chef's Specialties",
    Name: "Triple Delight",
    Price: 12.75,
    ItemDescription: "(Chicken, Beef, and Shrimp mixed in Brown Sauce)",
  },
  {
    Category: "Chef's Specialties",
    Name: "Four Seasons",
    Price: 12.75,
    ItemDescription:
      "(Beef, Jumbo Shrimp, Chicken, and Pork, sauteed in House Sauce)",
  },
  {
    Category: "Chef's Specialties",
    Name: "Teriyaki Tofu",
    Price: 11.5,
    ItemDescription: "(Grilled Tofu with Teriyaki Sauce)",
  },
  {
    Category: "Chef's Specialties",
    Name: "Teriyaki Seafood",
    Price: 13.95,
    ItemDescription: "(Grilled Jumbo Shrimp, Scallops, and Krab Meat)",
  },
];

const SushiEntrees = [
  {
    Category: "Sushi Bar Entrees",
    Name: "Sushi Regular",
    Price: 13.75,
    ItemDescription: "(7 pieces of Sushi and 1 California Roll)",
    CategoryDesc: "(With Seaweed Salad or Miso Soup)",
  },
  {
    Category: "Sushi Bar Entrees",
    Name: "Sushi Deluxe",
    Price: 15.75,
    ItemDescription: "(9 pieces of Sushi and 1 Tuna Roll)",
  },
  {
    Category: "Sushi Bar Entrees",
    Name: "Sashimi Deluxe (9 Pieces)",
    Price: 11.95,
  },
  {
    Category: "Sushi Bar Entrees",
    Name: "Sashimi Deluxe (18 Pieces)",
    Price: 22.5,
  },
  {
    Category: "Sushi Bar Entrees",
    Name: "Sushi Sashimi Combo",
    Price: 20.75,
    ItemDescription:
      "(9 pieces of Sashimi, 5 pieces of Sushi, and 1 California Roll)",
  },
];

const SushiRolls = [
  {
    Category: "Sushi Rolls",
    Name: "Cucumber Roll",
    Price: 4.25,
    CategoryDesc: "(Checkmark indicates Sushi without raw fish)",
    noRawFish: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "Avocado Roll",
    Price: 4.25,
    noRawFish: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "California Roll",
    Price: 5.35,
    noRawFish: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "Spicy California Roll",
    Price: 5.35,
    noRawFish: true,
    isSpicy: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "Tuna Roll",
    Price: 5.35,
  },
  {
    Category: "Sushi Rolls",
    Name: "Salmon Roll",
    Price: 5.35,
  },
  {
    Category: "Sushi Rolls",
    Name: "Spicy Salmon Roll",
    Price: 5.35,
    isSpicy: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "Yellow Tail Scallion",
    Price: 5.35,
    isSpicy: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "Eel Roll",
    Price: 5.35,
    noRawFish: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "Alaska Roll",
    Price: 5.35,
    ItemDescription: "(Salmon, Avocado, and Cucumber)",
  },
  {
    Category: "Sushi Rolls",
    Name: "Boston Roll",
    Price: 5.35,
    ItemDescription: "(Shrimp, Avocado, and Cucumber)",
  },
  {
    Category: "Sushi Rolls",
    Name: "Spicy Tuna Roll",
    Price: 5.35,
    isSpicy: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "Philadelphia Roll",
    Price: 5.35,
    ItemDescription: "(Smoked Salmon, Cream Cheese, and Cucumber)",
  },
  {
    Category: "Sushi Rolls",
    Name: "White Tuna Avocado Roll",
    Price: 5.35,
  },
  {
    Category: "Sushi Rolls",
    Name: "Shrimp Tempura Roll",
    Price: 7.95,
    ItemDescription:
      "(Deep Fried Shrimp, Cucumber, and Cream Cheese with Tobiko)",
    noRawFish: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "Tampa Roll",
    Price: 7.95,
    ItemDescription: "(Tempura Fish, Avocado, and Cream Cheese)",
  },
  {
    Category: "Sushi Rolls",
    Name: "Spicy Yellowtail Roll",
    Price: 5.75,
    isSpicy: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "Rainbow Roll",
    Price: 9.5,
    ItemDescription:
      "(California Roll topped with Salmon, Whitefish, and Tuna)",
  },
  {
    Category: "Sushi Rolls",
    Name: "Red Dragon Roll",
    Price: 9.75,
    ItemDescription: "(Spicy Tuna Roll topped with Tuna and Avocado)",
  },
  {
    Category: "Sushi Rolls",
    Name: "Black Dragon Roll",
    Price: 9.75,
    ItemDescription: "(Shrimp Tempura Roll topped with Eel and Avocado)",
    noRawFish: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "White Dragon Roll",
    Price: 9.75,
    ItemDescription:
      "(Spicy Salmon and Crunchy topped with White Tuna and Wasabi)",
  },
  {
    Category: "Sushi Rolls",
    Name: "Volcano Roll",
    Price: 9.95,
    ItemDescription: "(Salmon, Whitefish, Krab Meat and Avocado with Tobiko)",
  },
  {
    Category: "Sushi Rolls",
    Name: "Spider Roll",
    Price: 9.95,
    ItemDescription:
      "(Soft Shell Crab, Avocado, Cucumber, and Cream Cheese w/ Tobiko)",
    noRawFish: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "TNT Roll",
    Price: 9.75,
    ItemDescription: "(Tuna and Avocado topped with Spicy Tuna)",
    noRawFish: true,
    isSpicy: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "Tempura Roll   Deep Fried",
    Price: 8.25,
    ItemDescription: "(Whitefish, Scallion, and Cream Cheese)",
    noRawFish: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "Las Vegas Roll   Deep Fried",
    Price: 8.25,
    ItemDescription: "(Salmon, Cream Cheese, and Avocado)",
    noRawFish: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "Mexican Roll",
    Price: 7.95,
    ItemDescription:
      "(Deep Fried Shrimp, Avocado, and Cream Cheese with Tobiko)",
    noRawFish: true,
  },
  {
    Category: "Sushi Rolls",
    Name: "Chopstick Roll",
    Price: 9.25,
    ItemDescription: "(Shrimp Tempura with Spicy Tuna, Cream Cheese, Avocado)",
  },
  {
    Category: "Sushi Rolls",
    Name: "St. Petersburg Roll",
    Price: 9.5,
    ItemDescription:
      "(Shrimp Tempura w/ Cream Cheese, Avocado and Spicy Krab Meat)",
  },
  {
    Category: "Sushi Rolls",
    Name: "Florida Roll",
    Price: 9.25,
    ItemDescription:
      "(Spicy Tuna, Smoked Salmon, Whitefish, and Scallion, all Deep Fried)",
  },
  {
    Category: "Sushi Rolls",
    Name: "Yummi Roll",
    Price: 9.75,
    ItemDescription:
      "(Tuna and Cream Cheese topped with Salmon, Tobiko, and Wasabi)",
  },
  {
    Category: "Sushi Rolls",
    Name: "Tokyo Roll",
    Price: 9.75,
    ItemDescription:
      "(Shrimp Tempura Roll with Cucumber topped with Spicy Tuna)",
  },
  {
    Category: "Sushi Rolls",
    Name: "Fire Island Roll",
    Price: 9.25,
    isSpicy: true,
    noRawFish: true,
    ItemDescription: "(Spicy Krab Meat, Lobster, and Cream Cheese)",
  },
  {
    Category: "Sushi Rolls",
    Name: "Magic Roll",
    Price: 9.25,
    isSpicy: true,
    noRawFish: true,
    ItemDescription: "(Shrimp, Spicy Krab Meat, and Cream Cheese)",
  },
];

const Combo = [
  {
    Category: "Combo",
    Name: "8 Piece Chicken Wings Combo",
    Price: 7.95,
    CategoryDesc: "(Choose your choice of rice/noodle and side)",
  },
  {
    Category: "Combo",
    Name: "Teriyaki Chicken Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Teriyaki Beef Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Teriyaki Shrimp Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Teriyaki Chicken Breast Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Bourbon Chicken Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Sweet and Sour Chicken Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "General Tso's Chicken Combo",
    Price: 7.95,
    isSpicy: true,
  },
  {
    Category: "Combo",
    Name: "Sesame Chicken Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Black Pepper Chicken Combo",
    Price: 7.95,
    isSpicy: true,
  },
  {
    Category: "Combo",
    Name: "Shrimp Lo Mein Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Chicken Lo Mein Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Chicken with Broccoli Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Beef with Broccoli Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Shrimp with Broccoli Combo",
    Price: 7.95,
  },

  {
    Category: "Combo",
    Name: "Pepper Steak with Onion Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Mongolian Beef Combo",
    Price: 7.95,
    isSpicy: true,
  },
  {
    Category: "Combo",
    Name: "Kung Pao Chicken Combo",
    Price: 7.95,
    isSpicy: true,
  },
  {
    Category: "Combo",
    Name: "Chicken with Garlic Sauce Combo",
    Price: 7.95,
    isSpicy: true,
  },
  {
    Category: "Combo",
    Name: "Beef with Garlic Sauce Combo",
    Price: 7.95,
    isSpicy: true,
  },
  {
    Category: "Combo",
    Name: "Shrimp with Garlic Sauce Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Hunan Chicken Combo",
    Price: 7.95,
    isSpicy: true,
  },
  {
    Category: "Combo",
    Name: "Hunan Beef Combo",
    Price: 7.95,
    isSpicy: true,
  },
  {
    Category: "Combo",
    Name: "Szechuan Chicken Combo",
    Price: 7.95,
    isSpicy: true,
  },
  {
    Category: "Combo",
    Name: "Szechuan Beef Combo",
    Price: 7.95,
    isSpicy: true,
  },
  {
    Category: "Combo",
    Name: "Chicken with Cashews Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Shrimp with Cashews Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Moo Goo Gai Pan (Chicken) Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Chicken Chow Mein Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Pork Chow Mein Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Shrimp Chow Mein Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Beef Chow Mein Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Chicken with Mixed Veggies Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Beef with Mixed Veggies Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Shrimp with Mixed Veggies Combo",
    Price: 7.95,
  },
  {
    Category: "Combo",
    Name: "Shrimp with Lobster Sauce Combo",
    Price: 7.95,
  },
];

export {
  Appetizers,
  FriedRice,
  LoMein,
  Soup,
  Vegetables,
  DietFood,
  Chicken,
  Beef,
  Seafood,
  Teriyaki,
  ChowMein,
  ChefsSpecialties,
  SushiEntrees,
  SushiRolls,
  Combo,
};